import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p418247025609486336',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
